import {
  CREATE_TEST_RESULT,
  DELETE_TEST_RESULT,
  EDIT_TEST_RESULT,
  RECEIVE_TEST_RESULTS,
  REQUEST_ALL_TEST_RESULTS,
  REQUEST_TEST_RESULT,
} from '@sophocles/entities/TestResult/testResultActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_TEST_RESULTS: // Read
      return state.merge(action.testResults);
    case DELETE_TEST_RESULT: // Delete
      return state.delete(action.testResult.toString());
    case EDIT_TEST_RESULT: // Update
    case CREATE_TEST_RESULT: // Create
    case REQUEST_TEST_RESULT:
    case REQUEST_ALL_TEST_RESULTS:
    default:
      return state;
  }
}

export function testResultReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_TEST_RESULT:
    case DELETE_TEST_RESULT:
    case RECEIVE_TEST_RESULTS:
    case EDIT_TEST_RESULT:
    case REQUEST_TEST_RESULT:
    case REQUEST_ALL_TEST_RESULTS:
      return getState(state, action);
    default:
      return state;
  }
}
